module.exports = __webpack_public_path__ + "static/media/logo-ing.dcba1cde.png";